<template>
  <div>
    <h4 class="mb-4">Course Setting</h4>
    <vs-row class="border_btm pb-4">
      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <div class="grey_border h-full p-4">
          <!-- exams -->
          <vs-row class="items-center py-1">
            <vs-col vs-lg="8" vs-sm="12" class="py-2 position-relative">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch v-model="courseContentSetting.has_exam" />
                  <span class="px-2">Exams</span>
                </div>
                <div class="inline-flex">
                  <span class="material-icons-outlined info_pointer">info</span>
                  <div class="tooltip_holder">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12" class="sm:pl-2 pl-0 py-2">
              <vs-input
                v-model="courseContentSetting.exam_count"
                onkeypress="return (event.charCode >= 48)"
                 min="0"
                type="number"
                class="cstm_vue_select w-full"
                :disabled="!courseContentSetting.has_exam"
              />
            </vs-col>
          </vs-row>

          <!-- coursework -->
          <vs-row class="items-center py-1">
            <vs-col vs-lg="8" vs-sm="12" class="py-2 position-relative">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch v-model="courseContentSetting.has_coursework" />
                  <span class="px-2">Coursework</span>
                </div>
                <div class="inline-flex">
                  <span class="material-icons-outlined info_pointer">info</span>
                  <div class="tooltip_holder">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12" class="sm:pl-2 pl-0 py-2">
              <vs-input
                v-model="courseContentSetting.coursework_count"
                onkeypress="return (event.charCode >= 48)"
                min="0"
                type="number"
                class="cstm_vue_select w-full"
               
                :disabled="!courseContentSetting.has_coursework"
              />
            </vs-col>
          </vs-row>

          <!-- Progress Reports -->
          <!-- <vs-row class="items-center py-1">
            <vs-col vs-lg="8" vs-sm="12" class="py-2 position-relative">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch v-model="courseContentSetting.has_report" />
                  <span class="px-2">Progress Reports</span>
                </div>
                <div class="inline-flex">
                  <span class="material-icons-outlined info_pointer">info</span>
                  <div class="tooltip_holder">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12" class="sm:pl-2 pl-0 py-2">
              <vs-input
                v-model="courseContentSetting.report_count"
                type="number"
                class="cstm_vue_select w-full"
                placeholder="Type here..."
                :disabled="!courseContentSetting.has_report"
              />
            </vs-col>
          </vs-row> -->
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <div class="grey_border h-full p-4">
          <!-- Structured content -->
          <vs-row class="items-center">
            <vs-col vs-lg="8" vs-sm="12" class="py-3">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch
                    v-model="courseContentSetting.structured_content"
                  />
                  <span class="px-2">Structured content</span>
                </div>
              </div>
            </vs-col>
            <vs-col
              vs-lg="4"
              vs-sm="12"
              class="sm:pl-2 pl-0 py-3 position-relative flex items-center"
            >
              <div class="inline-flex justify-end w-full">
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </div>
              </div>
            </vs-col>
          </vs-row>

          <!-- Content Visibility -->
          <vs-row class="items-center">
            <vs-col vs-lg="8" vs-sm="12" class="py-3">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch
                    v-model="courseContentSetting.content_visibility"
                  />
                  <span class="px-2">Content Visibility</span>
                </div>
              </div>
            </vs-col>
            <vs-col
              vs-lg="4"
              vs-sm="12"
              class="sm:pl-2 pl-0 py-3 position-relative flex items-center"
            >
              <div class="inline-flex justify-end w-full">
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </div>
              </div>
            </vs-col>
          </vs-row>
          <!-- Chat -->
          <vs-row class="items-center">
            <vs-col vs-lg="8" vs-sm="12" class="py-3">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch v-model="courseContentSetting.chat" />
                  <span class="px-2">Chat</span>
                </div>
              </div>
            </vs-col>
            <vs-col
              vs-lg="4"
              vs-sm="12"
              class="sm:pl-2 pl-0 py-3 position-relative flex items-center"
            >
              <div class="inline-flex justify-end w-full">
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </div>
              </div>
            </vs-col>
          </vs-row>
            <!-- Certificate -->
          <vs-row class="items-center">
            <vs-col vs-lg="8" vs-sm="12" class="py-3">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch v-model="courseContentSetting.certificate" />
                  <span class="px-2">Certificate</span>
                </div>
              </div>
            </vs-col>
            <vs-col
              vs-lg="4"
              vs-sm="12"
              class="sm:pl-2 pl-0 py-3 position-relative flex items-center"
            >
              <div class="inline-flex justify-end w-full">
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <div class="grey_border h-full p-4">
          <!-- Course Access Expiration -->
          <vs-row class="items-center">
            <vs-col vs-lg="8" vs-sm="12" class="py-5 position-relative">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch
                  @change="course_access_expirationChange"
                    v-model="courseContentSetting.course_access_expiration"
                  />
                  <span class="px-2">Course Access Expiration</span>
                </div>
              </div>
            </vs-col>
          </vs-row>

          <!-- Access period -->
          <vs-row class="items-center">
            <vs-col vs-lg="8" vs-sm="12" class="py-5 position-relative">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch v-model="courseContentSetting.access_period" />
                  <span class="px-2">Access period</span>
                </div>
                <div class="inline-flex">
                  <span class="material-icons-outlined info_pointer">info</span>
                  <div class="tooltip_holder">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </div>
                </div>
              </div>
            </vs-col>
            <vs-col
              vs-lg="4"
              vs-sm="12"
              class="sm:pl-2 pl-0 py-2 inline-flex items-center"
            >
              <vs-input
              v-model="courseContentSetting.access_period_no"
              onkeypress="return (event.charCode >= 48)"
              min="0"
                type="number"
                class="cstm_vue_select w-full"
                :disabled="!courseContentSetting.access_period"
              />
              <span class="pl-2">Days</span>
            </vs-col>
          </vs-row>

          <!-- Data deletion -->
          <vs-row class="items-center" v-if="courseContentSetting.course_access_expiration">
            <vs-col vs-lg="8" vs-sm="12" class="py-5">
              <div class="flex flex-wrap justify-between items-center">
                <div class="inline-flex">
                  <vs-switch v-model="courseContentSetting.data_deletion" />
                  <span class="px-2">Data deletion</span>
                </div>
              </div>
            </vs-col>
            <vs-col
              vs-lg="4"
              vs-sm="12"
              class="sm:pl-2 pl-0 py-2 position-relative"
            >
              <div class="inline-flex w-full justify-end">
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>

    <div class="border_btm py-4" v-if="courseContentSetting.certificate">
      <h4 class="mb-4">Certifcate Award Method</h4>
      <div class="py-4">
        <vs-radio
          v-model="courseContentSetting.certificate_award_method_id"
          name="c_method"
          vs-value="1"
          class="pr-4"
        >
          Automatic
        </vs-radio>
        <vs-radio
          v-if="courseStructure.course_type.type != 'self_based'"
          v-model="courseContentSetting.certificate_award_method_id"
          name="c_method"
          vs-value="2"
        >
          Manual
        </vs-radio>
      </div>
      <div class="image_preview_holder mx-auto" v-if="!preview">
        <div
          class="flex flex-col justify-center items-center w-full h-full"
        >
          <svg
            width="223"
            height="106"
            viewBox="0 0 223 106"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.3157 105.999H150.248C155.051 105.999 157.907 100.637 155.227 96.6512L109.693 28.9335C107.748 26.041 103.756 25.409 101.013 27.5592L14.6144 95.2768C10.1269 98.7941 12.614 105.999 18.3157 105.999Z"
              fill="#C8C8C8"
            />
            <path
              d="M129.375 106H211.738C216.541 106 219.397 100.639 216.718 96.6531L188.292 54.3586C186.347 51.4648 182.353 50.8325 179.61 52.984L125.673 95.2785C121.187 98.7964 123.674 106 129.375 106Z"
              fill="#C8C8C8"
            />
            <circle cx="151.145" cy="17.0526" r="17.0526" fill="#C8C8C8" />
          </svg>
        </div>
      </div>
        <!-- <input type="file" accept="image/*" @change="previewImage"> -->
      <template v-if="preview">
        <!-- <img :src="preview" class="image" /> -->
        <div v-if="preview" icon="feather icon-settings">
          <div
            v-if="preview.certificate_image_details == null"
            v-html="preview.content"
            class="text-center previewed_action_holder"
          ></div>
          <div
            v-else
            v-html="preview.content"
            class="text-center"
            style="aspect-ratio: 1.414; background-repeat: no-repeat; background-position: center;"
            :style="{
              backgroundImage:
                'url(' +
                preview.certificate_image_details.file.file_path +
                ')'
            }"
          >
         </div>
        </div>
      </template>
      <vs-button
        @click="template_list = true"
        class="custom-file-input certificate_button"
      ></vs-button>
      <!-- <input
        type="file"
        accept="image/*"
        @change="template_list=true"
        class="custom-file-input certificate_button"
      /> -->
    </div>
    <div class="flex flex-wrap justify-between items-center mt-4">
       <vs-button type="border" @click="prevPage" v-if="!$route.params.course_id"
      >Back</vs-button
    >
    <vs-button @click="enrollCourseContent()" 
      >Save & Next</vs-button
    >
    </div>
    <vs-popup title="Template List" :active.sync="template_list">
      <vs-table class="cstm_vuexy_table" :data="courseTempList">
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th style="width: 240px;"> Certificate Name </vs-th>
          <vs-th style="width: 325px;"> Certificate Description </vs-th>
          <vs-th style="width: 325px;">Preview </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr]">
              <vs-checkbox
                :checked="
                  courseContentSetting.certificate_template_id ==
                    data[indextr].certificate_template_id
                "
                @change="handleChange(data[indextr])"
              ></vs-checkbox>
            </vs-td>
            <vs-td :data="data[indextr].title">
              {{ data[indextr].title }}
            </vs-td>
            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>
            <vs-td>
              <div class="flex">
                <vs-button
                  class="mx-1"
                  icon-pack="feather"
                  @click="previewFun(data[indextr])"
                  icon="icon-eye"
                  type="filled"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-card v-if="previewModal">
        <previewTemp :tempDetail="tempDetails"> </previewTemp>
      </vs-card>
      <vs-button color="primary" @click="template_list = false" type="filled"
        >Save</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import previewTemp from '../../../Testing/previewTemplate'
import vSelect from 'vue-select'
import { fetchcourseTem } from '@/api/certificate'

import {
  updateCourseContentSetting,
  getCourseContent
} from '@/api/courseBuilder.js'

export default {
  props: {
    courseId: {
      required: true,
      default: null
    },
    counter: {
      required: true,
      default: 0
    }
  },
  data () {
    return {
      previewModal: false,
      template_list: false,
      courseTempList: [],
      courseContentSetting: {
        access_period_no:null,
        has_exam: false,
        has_coursework: false,
        has_report: false,
        structured_content: false,
        content_visibility: false,
        certificate: false,
        chat: false,
        course_access_expiration: false,
        access_period:false,
        data_deletion: false,
        course_id: this.course_id,
        coursework_count: 0,
        exam_count: 0,
        report_count: null,
        certificate_award_method_id:2,

        certificate_template_id: null
      },

      customer_id: localStorage.getItem('customer_id'),
      c_method: 'Manual',
      preview: null,
      image: null,
      course_id: null,
      tempDetails: '',
      courseStructure:''
    }
  },
  watch: {
    counter () {
      // if (this.counter === 4) {
      this.course_id = this.courseId
      this.fetchCourseContentSettings()
      // }
    }
  },
  components: {
    vSelect,
    previewTemp
  },
  mounted () {
    if (this.course_id) {
      this.fetchCourseContentSettings()
    }
    
    this.fetchTemplateList()
  },
  methods: {
    course_access_expirationChange () {
      this.courseContentSetting.access_period = this.courseContentSetting.course_access_expiration
    },
    async prevPage () {
      this.$emit('prevPage', 3)
    },
    async enrollCourseContent () {
      try {
        const payload = {
          courseContentSetting: this.courseContentSetting
        }
        const data = await updateCourseContentSetting(
          this.customer_id,
          this.course_id,
          payload
        )
        this.$emit('nextTab', 5)
      } catch (e) {
        console.log(e)
      }
    },
    handleChange (data) {
      this.courseContentSetting.certificate_template_id =
        data.certificate_template_id
      this.preview = data
    },
    previewFun (data) {
      this.previewModal = true
      this.tempDetails = data
    },
    async fetchTemplateList () {
      try {
        const responseCurrency = await fetchcourseTem(
          this.$store.getters.customerId
        )
        this.courseTempList =
          responseCurrency.data.data.certificate_template_list
        if (this.courseContentSetting.certificate_template_id) {
          const res = this.courseTempList.filter(ele => {
            if (
              ele.certificate_template_id ===
              this.courseContentSetting.certificate_template_id
            ) {
              return ele
            }
          })
          this.preview = res[0]
          console.log(this.preview)
          console.log(this.courseTempList)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchCourseContentSettings () {
      try {
        const data = await getCourseContent(
          this.customer_id,
          this.course_id
        )
        if (data.data.data.course.courseContentSetting !== null) {
          this.courseContentSetting = data.data.data.course.courseContentSetting
        }
        
       
        this.fetchTemplateList()
        this.courseStructure = data.data.data.course.courseStructure
        console.log(this.courseStructure)
       
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
